/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  Grid,
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
} from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import logo from '../../assets/img/frota_maxima.png';
import NumberFormat from '../../utils/NumberFormat';
import { ContainerPainel } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import axios from '../../services/axios';

export default function DashHome() {
  const [viagens, setViagens] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const mesAtual = new Date().toLocaleString('pt-BR', { month: 'long' });
  const maxReceita = Math.max(...viagens.map((v) => v.totalReceitas), 0);

  useEffect(() => {
    async function fetchAll() {
      setIsLoading(true);
      try {
        const response = await axios.get('/viagens/dashHome');
        setViagens(response.data);
      } catch (error) {
        toast.error('Erro ao carregar viagens:', error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchAll();
  }, []);

  const totalizador = viagens.reduce(
    (acc, viagem) => {
      acc.receitas += Number(viagem.totalReceitas) || 0;
      return acc;
    },
    { receitas: 0 }
  );

  return (
    <ContainerPainel>
      <Loading isLoading={isLoading} />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          position: 'relative', // Isso permitirá posicionar a imagem absolutamente dentro desta div
        }}
      >
        <img
          src={logo} // Substitua "URL_DA_IMAGEM" pelo URL real da imagem
          alt="Frota Máxima"
          style={{
            // position: 'absolute', // Posiciona a imagem de forma absoluta
            maxWidth: '20%', // Limita a largura da imagem para não exceder o contêiner
            maxHeight: '20%', // Limita a altura da imagem para não exceder o contêiner
            opacity: 0.5, // Define a opacidade para dar um efeito de marca d'água
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          position: 'relative',
        }}
      >
        <Grid container spacing={2} alignItems="center">
          {/* Totalizador */}
          <Grid item xs={12} sm={6}>
            <Card
              style={{
                border: '1px solid black',
                color: 'black',
                borderRadius: '10px',
                backgroundColor: 'yellow',
              }}
            >
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Total Receitas x Veículo (
                  {mesAtual.charAt(0).toUpperCase() + mesAtual.slice(1)})
                </Typography>
                <Typography variant="h3">
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <span>R${NumberFormat(totalizador.receitas)}</span>
                  </div>
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Gráfico de Barras */}
          <Grid item xs={12} sm={6}>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={viagens.filter((v) => v.totalReceitas >= 10)}
                margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
              >
                <XAxis
                  dataKey="placa"
                  angle={-45}
                  textAnchor="end"
                  tick={{ fontSize: 12 }}
                />
                <YAxis
                  domain={[
                    0,
                    (dataMax) => Math.max(dataMax, maxReceita) * 1.1 || 100,
                  ]}
                  tickCount={5}
                  allowDecimals={false}
                  tickFormatter={(value) => value.toFixed(0)}
                />
                <Tooltip
                  formatter={(value) => `R$ ${Number(value).toFixed(2)}`}
                />
                <Bar dataKey="totalReceitas" name="Receitas" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </Grid>
        </Grid>
      </div>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
          maxWidth: { xs: '100%', sm: '80%', md: '80%' },
        }}
      >
        {/* Cards dos Veículos */}
        <Grid container spacing={2} style={{ marginTop: '20px' }}>
          {viagens.map((viagem, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                style={{
                  marginBottom: '10px',
                  border: '1px solid black',
                  color: 'black',
                  borderRadius: '10px',
                  backgroundColor:
                    viagem.totalReceitas >= 0 ? 'lightgreen' : 'lightcoral', // Condição para definir a cor do card
                }}
              >
                <CardContent>
                  <Typography variant="body2" gutterBottom>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>Veículo: {viagem.placa}</span>
                    </div>
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'black',
                      borderRadius: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <Typography variant="body2">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>Receitas (R$):</span>
                      <span>{NumberFormat(viagem.totalReceitas)}</span>
                    </div>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ContainerPainel>
  );
}
